import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supplierApi } from '../../api/supplier';

export function SupplierAnalyticsPage() {
  const [analytics, setAnalytics] = useState<{ total_suppliers: number; avg_performance: number; avg_risk: number } | null>(null);

  useEffect(() => {
    void supplierApi.analytics().then(setAnalytics);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/suppliers" className="text-sm text-slate-600 hover:underline">← Supplier hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Supplier analytics</h1>
      {analytics && (
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Total suppliers</p><p className="text-xl font-semibold">{analytics.total_suppliers}</p></div>
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Avg performance</p><p className="text-xl font-semibold">{analytics.avg_performance.toFixed(1)}</p></div>
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Avg risk</p><p className="text-xl font-semibold">{analytics.avg_risk.toFixed(1)}</p></div>
        </div>
      )}
    </div>
  );
}
